import { faqData } from '@/mocks/homeData';

export default function SectionFaq() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            关于吃瓜爆料，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-3 md:space-y-4">
          {faqData.map((item) => (
            <details
              key={item.id}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between p-4 md:p-5 list-none">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 pr-4">
                  {item.q}
                </h3>
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-background-100 flex items-center justify-center group-open:rotate-45 transition-transform">
                  <i className="ri-add-line text-foreground-600 text-sm"></i>
                </span>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed border-t border-background-200/70 pt-3">
                  {item.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}